import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { StaticRoutePaths } from '../Common/ClientRoutes';

import { getOrders } from './epics-orders';
import SingleOrder from './components/single-order';
import { CompanySelectV2, PharmacySelectV2, OrderStatusSelectV2 } from '../Common/form/Elements-export';
import { FormRow } from '../Common/form/formElements';
import Svgs from '../Common/Svgs';

import localStorage from '../Common/LocalStorage';
import LocalizedStrings from 'react-localization';
import { translations } from '../Common/Translations';
let strings = new LocalizedStrings(translations);
strings.setLanguage(localStorage.getFromStorage('lang'));

const header = [
    { name: strings.order_number, value: 'id' },
    {},
    { name: strings.client_name, value: 'user' },
    {},
    { name: strings.date_received, value: 'orderDate' },
    {},
    { name: strings.date_completed, value: 'completedOn' },
    {},
    { name: strings.order_status, value: 'status' }
];

class Orders extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderBy: 'orderDate',
            orderDirection: 'desc',
            page: 0,
            limit: 30,
            company: '',
            pharmacy: '',
            orders: [],
            count: 0,
            loadingTable: false,
            tableError: false,
            hasSelectedOrder: false,
            loadingPreview: false,
            orderDetails: {}
        };
    }

    getOrdersList() {
        getOrders({
            pharmacy_id: this.state.pharmacy,
            offset: this.state.limit * this.state.page,
            limit: this.state.limit,
            sortBy: this.state.orderBy + '.' + this.state.orderDirection,
            orderStatus: this.state.OrderStatus
        })
            .then(response => {
                if (response !== undefined && response.orders !== undefined) {
                    this.setState({
                        ...this.state,
                        orders: response.orders,
                        loadingTable: false,
                        count: response.count
                    });
                } else {
                    this.setState({
                        ...this.state,
                        loadingTable: false,
                        tableError: true
                    });
                }
            })
            .catch(error => {});
    }

    setCompany = company => {
        this.setState({ ...this.state, company: company });
    };

    setOrderStatus = OrderStatus => {
        this.setState({ ...this.state, OrderStatus: OrderStatus });
    };

    setPharmacy = pharmacy => {
        this.setState({ ...this.state, pharmacy: pharmacy});
    };

    componentDidUpdate(prevProps, prevState) {
        if (this.state.pharmacy !== prevState.pharmacy) {

            if (this.state.pharmacy !== '') {
                this.setState({
                    ...this.setState,
                    tableError: false,
                    loadingPreview: false,
                    hasSelectedOrder: false,
                    orderDetails: [],
                    loadingTable: true,
                    orders: []
                });
                this.getOrdersList();
            } else {
                this.setState({
                    ...this.setState,
                    tableError: false,
                    loadingPreview: false,
                    hasSelectedOrder: false,
                    orderDetails: [],
                    orders: []
                });
            }
        }

        if (this.state.OrderStatus !== prevState.OrderStatus && this.state.pharmacy !== '') {
            this.getOrdersList();
        }
        
        if (
            this.state.pharmacy !== '' &&
            (this.state.orderBy !== prevState.orderBy ||
                this.state.orderDirection !== prevState.orderDirection ||
                this.state.page !== prevState.page ||
                this.state.limit !== prevState.limit)
        ) {
            this.setState({
                ...this.setState,
                loadingTable: true,
                tableError: false,
                orders: []
            });
            this.getOrdersList();
        }
    }

    changeOrderBy = field => {
        if (this.state.orderBy === field && this.state.orderDirection === 'asc') {
            this.setState({
                ...this.setState,
                orderDirection: 'desc',
                page: 0
            });
        } else {
            this.setState({
                ...this.setState,
                orderBy: field,
                orderDirection: 'asc',
                page: 0
            });
        }
    };

    setPageNumber = pageNumber => {
        this.setState({
            ...this.setState,
            page: pageNumber
        });
    };

    generatePagination = () => {
        if (this.state.count !== undefined && this.state.orders.length && this.state.count > this.state.orders.length) {
            let pagesArr = Array.apply(null, { length: Math.ceil(this.state.count / parseInt(this.state.limit, 10)) }).map(
                Number.call,
                Number
            );
            return (
                <div className="row">
                    <div className="col qf-mb-30 text-center">
                        <nav aria-label="navigation">
                            <ul className="pagination justify-content-center">
                                <li className={'page-item' + (this.state.page === 0 ? ' disabled' : '')}>
                                    <a className="page-link" onClick={() => this.setPageNumber(0)}>
                                        {strings.first}
                                    </a>
                                </li>
                                {pagesArr.map(pageNumber => {
                                    if (this.state.page - 10 <= pageNumber && this.state.page + 10 >= pageNumber) {
                                        return (
                                            <li
                                                key={pageNumber}
                                                className={'page-item' + (this.state.page === pageNumber ? ' active' : '')}
                                            >
                                                <a className="page-link" onClick={() => this.setPageNumber(pageNumber)}>
                                                    {pageNumber + 1}
                                                </a>
                                            </li>
                                        );
                                    } else {
                                        return null;
                                    }
                                })}
                                <li className={'page-item ' + (this.state.page === pagesArr.length - 1 ? 'disabled' : '')}>
                                    <a className="page-link" onClick={() => this.setPageNumber(pagesArr.length - 1)}>
                                        {strings.last}
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    };

    onLimitChange = event => {
        this.setState({ ...this.state, limit: event.target.value, page: 0 });
    };

    openOrderDetails = orderId => {
        this.props.history.push(StaticRoutePaths.ORDER_DETAILS + '/' + orderId);
    };

    generateTableHead =  () => {
        let className = 'fa ';
        if (this.state.orderDirection === 'asc') {
            className += 'fa-angle-down';
        } else {
            className += 'fa-angle-up';
        }

        return (
            <thead>
                <tr>
                    {header.map((value, index) => {
                        if (value.name !== undefined) {
                            return (
                                <th key={index}>
                                    <div onClick={() => this.changeOrderBy(value.value)}>
                                        {value.name}
                                        {this.state.orderBy === value.value ? (
                                            <i className={className} />
                                        ) : (
                                            <i className={'qf-invisible ' + className} />
                                        )}
                                    </div>
                                </th>
                            );
                        } else {
                            return <th key={index}></th>;
                        }
                    })}
                </tr>
            </thead>
        );
    };

    generateTableBody = () => {
        return (
            <tbody>
                {this.state.loadingTable ? (
                    <tr>
                        <td colSpan={9} className="text-center p-3">
                            <i className="fa fa-spinner fa-spin fa-3x" />
                        </td>
                    </tr>
                ) : null}
                {this.state.tableError ? (
                    <tr>
                        <td colSpan={9} className="text-center p-3 qf-color-red">
                            {strings.something_went_wrong}
                        </td>
                    </tr>
                ) : null}
                {this.state.orders.length && !this.state.loadingTable
                    ? this.state.orders.map(singleOrder => {
                          return (
                              <SingleOrder
                                  key={singleOrder.id}
                                  data={singleOrder}
                                  openOrderDetails={this.openOrderDetails}
                              />
                          );
                      })
                    : null}
            </tbody>
        );
    };

    render() {
        return (
            <div className="container">
                <div className="row qf-mb-100">
                    <div className="col-1 light-blue-bg text-center pt-3">
                        <span className="qf-page-icon">{Svgs.orders}</span>
                    </div>
                    <div className="col-11 white-bg px-5">
                        <FormRow>
                            <div className="col-sm-3 mb-4">
                                <h2 className="qf-page-title pb-0">
                                    <i className="fa fa-info-circle mr-2" />
                                    {strings.Orders}
                                </h2>
                                <div className="qf-align-bottom">
                                    <hr className="qf-divider-line mb-0" />
                                </div>
                            </div>
                            <CompanySelectV2
                                role={this.props.status}
                                label={`* ${strings.Company}`}
                                handler={this.setCompany}
                                name="company"
                                extraClasses="col-3 mb-4 pt-3"
                            />
                            <PharmacySelectV2
                                role={this.props.status}
                                company={this.state.company}
                                label={`* ${strings.Pharmacy}`}
                                handler={this.setPharmacy}
                                name="pharmacy"
                                extraClasses="col-3 mb-4 pt-3"
                            />
                            <OrderStatusSelectV2
                                role={this.props.status}
                                label={`* ${strings.order_status}`}
                                handler={this.setOrderStatus}
                                name="order"
                                extraClasses="col-3 mb-4 pt-3"
                            />
                        </FormRow>
                        <div className="row">
                            <div className="formSelect col-3 offset-9 mb-3">
                                <div className="selectWrapper">
                                    <select value={this.state.limit} onChange={this.onLimitChange}>
                                        <option value={10}>{strings.formatString(strings.show_per_page, { num: 10 })}</option>
                                        <option value={20}>{strings.formatString(strings.show_per_page, { num: 20 })}</option>
                                        <option value={30}>{strings.formatString(strings.show_per_page, { num: 30 })}</option>
                                        <option value={40}>{strings.formatString(strings.show_per_page, { num: 40 })}</option>
                                        <option value={50}>{strings.formatString(strings.show_per_page, { num: 50 })}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="row qf-mb-30">
                            <div className="col-12">
                                <table className="qf-table qf-orders-table qf-mb-30">
                                    {this.generateTableHead()}
                                    {this.generateTableBody()}
                                </table>
                                {this.generatePagination()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Orders);



// WEBPACK FOOTER //
// ./src/customModules/Orders/component-list-orders.js